import { faFile } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"

export const RestoCard: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className='tw-border tw-border-gray-400 tw-rounded-md tw-bg-gray-50 tw-p-4 tw-flex tw-items-start tw-gap-2'>
      <FontAwesomeIcon
        icon={faFile}
        className='tw-text-lg tw-text-secondary'
      />
      <div>
        <div className='tw-text-md tw-font-medium'>
          {t("flujoAprobaciones.verificaciones.remainderTitle")}
        </div>
        <p className='tw-text-sm tw-mt-1'>
          {t("flujoAprobaciones.verificaciones.remainderDescription")}
        </p>
      </div>
    </div>
  )
}
